<div class="home-widgets">
  <ng-content #homeWidgets></ng-content>
</div>

<ng-template #placeholder>
  <div class="container-next-trips">
    <div class="item-next-trips"></div>
  </div>
</ng-template>

<ng-container *ngIf="flightOffersAreEnabled">
  <div class="flight-offers" [class.desktop-item]="!isMobile">
    <div class="content-section">
      <div class="header">
        <app-ds-typography
          [size]="fontSize.RG"
          [fontFamily]="fontFamily.SemiBold"
          [text]="'OFFERS_FLIGHT.UNBEATABLE_FLIGHT' | transloco"
          [color]="fontColor.Primary">
        </app-ds-typography>
        <app-ds-typography
          [tag]="'p'"
          [size]="fontSize.Smaller"
          [fontFamily]="fontFamily.Regular"
          [text]="('OFFERS_FLIGHT.BEST_OFFERS_FLIGHT_CITY' | transloco) | uppercase"
          [color]="fontColor.Secondary">
        </app-ds-typography>
      </div>
    </div>
    <div class="section-promo">
      <app-slide-flight-offers 
        [isMobile]="isMobile"
        [airline]="airline"
        [flightOffers]="flightOffers"
        [departurePlace]="departurePlace"
        [arrivalPlace]="departurePlace">
      </app-slide-flight-offers>
    </div>
  </div>
</ng-container>
<div #homeSectionList>
  <ng-container *ngFor="let section of homeSections; let i = index">
    <div [id]="section.html_id" class="content-section-promo" [class.desktop-item]="!isMobile" [class.isRappiCard]="section.exclusive_rappi_card">
      <div class="content-section" *ngIf="sectionNotExclusiveRappiCard(section)">
        <div class="header" *ngIf="section.title">
          <ng-container *ngIf="section.exclusive_rappi_card; else tileSection">
            <div class="title-rappicard">
              <img height="60" loading="lazy" [src]="rappiCardImage | ImageCdn">
              <app-ds-typography
                [size]="fontSize.RG"
                [fontFamily]="fontFamily.SemiBold"
                [text]="section.title"
                [color]="fontColor.Primary">
              </app-ds-typography>
            </div>
          </ng-container>
          <ng-template #tileSection>
            <app-ds-typography
              [size]="fontSize.RG"
              [fontFamily]="fontFamily.SemiBold"
              [text]="section.title"
              [color]="fontColor.Primary">
            </app-ds-typography>
          </ng-template>
          <ng-container *ngIf="section.sub_title">
            <div class="sub-title">
              <app-ds-typography
                [tag]="'p'"
                [size]="fontSize.Smaller"
                [fontFamily]="fontFamily.Regular"
                [text]="section.sub_title | uppercase"
                [color]="fontColor.Secondary">
              </app-ds-typography>
            </div>
          </ng-container>
          <ng-container *ngIf="isOnlyText(section)">
            <div class="text">
              <app-ds-typography
                [tag]="'p'"
                [size]="fontSize.Smaller"
                [fontFamily]="fontFamily.Regular"
                [text]="section.text"
                [color]="fontColor.Secondary">
              </app-ds-typography>
            </div>
          </ng-container>
        </div>
      </div>
      @defer (on viewport) {
        <ng-container [ngSwitch]="sectionType(section)">
          <div class="section-promo">
            <app-slide-promo
              *ngSwitchCase="sectionTypePromo"
              [isMobile]="isMobile"
              [promos]="section.promos"
              [index]="i"
              [source]="source"
              [branchCode]="branchCode"
              [salesChannel]="salesChannel"
              [isRappiCard]="section.exclusive_rappi_card"
              (selectedPromo)="clickPromo($event,i)"
              (htmlAnchor)="scrollToSectionHtmlId($event)"
              (htmlExternal)="openIframe($event)"
              (viewFinancialPartners)="toggleFinancialPartners($event)">
            </app-slide-promo>
            <app-slide-store
              *ngSwitchCase="sectionTypeStore"
              [isMobile]="isMobile"
              [stores]="section.stores"
              [index]="i"
              [source]="source"
              [branchCode]="branchCode"
              [salesChannel]="salesChannel"
              (selectedStore)="clickStore($event,i)"
              (htmlAnchor)="scrollToSectionHtmlId($event)"
              (htmlExternal)="openIframe($event)">
            </app-slide-store>
            <app-section-text
              *ngSwitchCase="sectionTypeText"
              [isMobile]="isMobile"
              [text]="section.text"
              [index]="i">
            </app-section-text>
            <app-slide-tile
              *ngSwitchCase="sectionTypeTile"
              [isMobile]="isMobile"
              [tiles]="section.tiles"
              [index]="i"
              [source]="source"
              [branchCode]="branchCode"
              [salesChannel]="salesChannel"
              (selectedTile)="clickTile($event,i)"
              (htmlAnchor)="scrollToSectionHtmlId($event)"
              (htmlExternal)="openIframe($event)">
            </app-slide-tile>
            <app-slide-banner
              *ngSwitchCase="sectionTypeBanner"
              [isMobile]="isMobile"
              [banners]="section.banners"
              [index]="i"
              [source]="source"
              [branchCode]="branchCode"
              [salesChannel]="salesChannel"
              (selectedBanner)="clickBanner($event,i)"
              (htmlAnchor)="scrollToSectionHtmlId($event)"
              (htmlExternal)="openIframe($event)">
            </app-slide-banner>
            <app-slide-hotel-promo 
              *ngSwitchCase="sectionTypeHotelPromo"
              [isMobile]="isMobile"
              [hotelPromos]="section.hotel_promos"
              [salesChannel]="salesChannel"
              [source]="source"
              [branchCode]="branchCode"
              [index]="i"
              [hasRappiCard]="hasRappiCard$ | async"
              [isPrime]="isPrime$ | async"
              [isLoggedIn]="isLoggedIn$ | async"
              [pageCode]="pageCode"
              (selectPromo)="clickHotelPromo($event,i)"
              (htmlAnchor)="scrollToSectionHtmlId($event)"
              (htmlExternal)="openIframe($event)"
              (viewFinancialPartners)="toggleFinancialPartners($event)">
            </app-slide-hotel-promo>
          </div>
        </ng-container>
      } @placeholder {
        <div></div>
      }
    </div>
  </ng-container>
</div>

<div #modalWebView class="modal-webview">
  <app-swipe-up [height]="90" [showSwipeUp]="false" (toggleShowSwipeUp)="toggleShowSwipeUp()">
    <ng-container content>
      <a (click)="toggleShowSwipeUp()" class="close-button">
        <i aria-hidden="true" class="icon-close"></i>
      </a>
      @defer (when iframeHasBeenRequested) {
        @if (loadingIframe) {
          <div class="loader">
            <app-travel-loader
              [domManipulateOff]="true">
            </app-travel-loader>
          </div>
        }
      }
      <iframe #iframeWebView (load)="loadIframe()" class="iframe" title="Modal WebView"></iframe>
    </ng-container>
  </app-swipe-up>
</div>

<app-financial-partners
  [totalPrice]="financialPartnersInfo?.totalPrice"
  [searchBy]="searchBySelected"
  [maxAmount]="financialPartnersInfo?.maxAmount"
  [showSwipeUp]="showFinancialPartners"
  [isDesktop]="!isMobile"
  (closeModal)="toggleFinancialPartners($event)">
</app-financial-partners>  